<!-- 门票支付 -->
<template>
  <div v-if="ticketFormStore.activeStep === 'pay'">
    <div class="realTimePay-container">
      <div class="main">
        <div class="order_info">
          <div class="price_area">
            {{ $t('ticket.paymentSection.orderAmount') }}
            <i>{{ payType === 'paypal' ? '$' : '￥' }}</i>
            <!--discountSwitch 0:关闭 1:打开-->
            <span class="price">
              {{ orderPrice }}
            </span>
          </div>
          <div class="order_tit">
            <div>
              {{ _get(ticketPageStore.fair, 'exhibitionName', '') }}
            </div>
            <div v-if="ticketDataStore.ticketFaceObj">
              {{ ticketDataStore.ticketFaceObj.typeName }}
              <template v-if="ticketDataStore.ticketFaceObj.timeSliceType&&ticketDataStore.ticketFaceObj.timeSliceType !== 0">
              {{ formatTicketDate(ticketDataStore.ticketFaceObj.startDate) }}<template v-if="ticketDataStore.ticketFaceObj.startDate !== ticketDataStore.ticketFaceObj.endDate">-{{ formatTicketDate(ticketDataStore.ticketFaceObj.endDate) }}</template>
                  (
                  <span v-if="ticketDataStore.ticketFaceObj.timeSliceType">
                    {{ timeSliceTypeLabels[ticketDataStore.ticketFaceObj.timeSliceType] }}
                  </span>
                  <span v-if="ticketDataStore.ticketFaceObj.startTimeSlice || ticketDataStore.ticketFaceObj.endTimeSlice">
                    {{ ticketDataStore.ticketFaceObj.startTimeSlice }}-{{ ticketDataStore.ticketFaceObj.endTimeSlice }}
                  </span>
                  )
            </template>
            <template v-else>
              {{ formatTicketDate(ticketDataStore.ticketFaceObj.startDate) }}
              <template v-if="ticketDataStore.ticketFaceObj.startDate !== ticketDataStore.ticketFaceObj.endDate">-{{ formatTicketDate(ticketDataStore.ticketFaceObj.endDate) }}</template>
            </template>
            </div>
            <!-- <div v-if="false">
              <span v-if="ticketDataStore.ticketType === 1">
                单日票
                {{ moment(ticketPageStore.singleDayPrice.singleDay).format('MM月DD日') }}
              </span>
              <span v-if="ticketDataStore.ticketType === 2">
                展期票
                {{ moment(ticketPageStore.fair.startTime).format('MM月DD日') }}-{{
                  moment(ticketPageStore.fair.endTime).format('MM月DD日')
                }}
              </span>
              <template v-if="ticketDataStore.ticketType >= 100">
                <span v-if="ticketDataStore.ticketType >= 100">
                  {{ ticketTypeName }}
                </span>
                <span v-if="ticketPageStore.groupPrice.timeSliceType == 0">
                  {{ moment(ticketPageStore.groupPrice.startDate).format('MM月DD日') }}-{{
                    moment(ticketPageStore.groupPrice.endDate).format('MM月DD日')
                  }}
                </span>
                <span v-else>
                  {{ moment(ticketPageStore.groupPrice.startDate).format('MM月DD日') }}
                </span>
                <span v-if="ticketPageStore.groupPrice.timeSliceType != 0">
                  ({{ timeSliceTypeOptions[ticketPageStore.groupPrice.timeSliceType] }}:{{
                    ticketPageStore.groupPrice.startTimeSlice
                  }}-{{ ticketPageStore.groupPrice.endTimeSlice }})
                </span>
              </template>
            </div> -->
            <div class="fair-name-en">
              {{ _get(ticketPageStore.fair, 'exhibitionEnglishName', '') }}
            </div>
          </div>
        </div>
        <p class="back_box">
          <span @click="handleBack">&lt;{{ $t('ticket.modifyOrder') }}</span>
        </p>

        <PaymentType
          :data="payStore.orderInfo"
          :visible="props.showHzBankPay"
          @onPaytype="onChangePayType"></PaymentType>
      </div>
      <div class="safety_md_content">
        <div class="safety_md">{{ $t('ticket.paymentSecurity') }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { defineAsyncComponent, h, watch, nextTick, ref, computed } from 'vue'
  import _get from 'lodash/get'
  import moment from 'moment'
  import currency from 'currency.js'

  import { renderPayPalButtons } from '~/composables/usePayPalSdk'
  // @ts-ignore
  // import vueQr from 'vue-qr/src/packages/vue-qr.vue'

  // 导入组件
  const PaymentType = defineAsyncComponent(() => import('~/pages/manager/components/PaymentType.vue'))

  interface Props {
    showHzBankPay?: boolean
  }
  const props = withDefaults(defineProps<Props>(), {
    showHzBankPay: false
  })

  watch(
    () => [props.showHzBankPay] as const,
    async ([show]) => {
      if (show) {
        console.log('选择支付方式组件--222', show)
      }
    },
    { immediate: true }
  )

  interface Emits {
    (e: 'back'): void

    (e: 'toggle-payment', type: string): void

    (e: 'to-pay'): void
  }

  const emit = defineEmits<Emits>()

  // 使用 stores
  const ticketDataStore = useTicketDataStore()
  const ticketFormStore = useTicketFormStore()
  const ticketPageStore = useTicketPageStore()
  const payStore = usePayStore()
  const priceCalculations = useTicketPrice()
  const actions: any = useTicketActions()
  const { t } = useI18n()

  const payType = ref('')

  const onChangePayType = (val: string) => {
    payType.value = val
    console.log('支付类型变更--', val)
  }

  // 订单金额
  const orderPrice = computed(() => {
    let result: any = 0
    if (payType.value === 'paypal') {
      // paypal支付
      if (ticketDataStore.ticketPrice.discountSwitch === 1) {
        // 有折扣
        result = currency(priceCalculations.countPrice.value)
          .subtract(priceCalculations.discountsPrice.value)
          .divide(payStore.usdRate)
      } else {
        // 无折扣
        result = currency(priceCalculations.countPrice.value).divide(payStore.usdRate)
      }
    } else {
      // 微信/支付宝
      if (ticketDataStore.ticketPrice.discountSwitch === 1) {
        // 有折扣
        result = currency(priceCalculations.countPrice.value).subtract(priceCalculations.discountsPrice.value)
      } else {
        // 无折扣
        result = currency(priceCalculations.countPrice.value)
      }
    }
    return result
  })

  // 从其他 store 获取数据

  // 当展示 PayPal 按钮容器且已有 orderId/clientId 时，加载 SDK 并渲染按钮
  watch(
    () => [payStore.showPayPalButton, payStore.paypalOrderId, payStore.paypalClientId, payStore.payScene] as const,
    async ([show, orderId, clientId, payScene]) => {
      if (!show || !orderId || !clientId || typeof document === 'undefined') return
      if (payScene == 2) {
        console.log('payScene-支付场景-订单已存在-跳过PayPal按钮渲染')
        return
      }
      await nextTick()
      try {
        await renderPayPalButtons(clientId, orderId, '#paypal-button-container-ticket', approvedOrderId =>
          actions.capturePayPalAndRedirect(approvedOrderId)
        )
      } catch (e) {
        console.error('PayPal buttons render failed:', e)
      }
    },
    { immediate: true }
  )

  // 计算属性
  const ticketTypeName = computed(() => {
    const ticketTypeMap: Record<number, string> = {}
    return ticketTypeMap[ticketDataStore.ticketType] || t('ticket.paymentSection.otherTicket')
  })

  const timeSliceTypeLabels = computed<Record<number, string>>(() => ({
    0: t('ticket.ticketSelection.timeSlice.fullDay'),
    1: t('ticket.ticketSelection.timeSlice.morning'),
    2: t('ticket.ticketSelection.timeSlice.afternoon'),
    3: t('ticket.ticketSelection.timeSlice.evening')
  }))

  const formatTicketDate = (date: string) => moment(date).format(t('ticket.ticketSelection.dateFormat'))

  const handleBack = () => {
    actions.back()
  }
</script>

<style lang="less" scoped>
  .realTimePay-container {
    padding: 12px 0 0 0;

    .main {
      width: 854px;
      margin: 0 auto;

      .order_info {
        height: 112px;
        display: flex;
        justify-content: space-between;
        background: #f4f7fe;
        box-shadow: 1px 2px 15px #e6e6e6;
        border-radius: 4px;
        overflow: hidden;
        position: relative;

        &::after {
          content: '';
          display: inline-block;
          position: absolute;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: #e6e6e6;
          bottom: -7px;
          left: 430px;
        }

        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: #e6e6e6;
          top: -7px;
          left: 430px;
        }

        .price_area {
          width: 437px;
          padding: 22px 20px 20px;

          i {
            font-style: unset;
            color: #e50113;
          }

          .price {
            font-size: 24px;
            font-weight: 700;
            color: #e50113;
          }
        }

        .order_tit {
          background: #f9fdff;
          width: 753px;
          padding: 22px 20px 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .fair-name-en {
            font-weight: bold;
            color: #e50113;
          }
        }
      }

      .tabs_box {
        margin-top: 15px;
        background: #fff;
        border-radius: 4px;

        .tabs_tit {
          padding: 0 20px 0 40px;
          overflow: hidden;
          border-bottom: 1px solid #ddd;

          li {
            float: left;
            width: 95px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 18px;
            font-weight: 500;
            color: #999;
            margin-right: 20px;
            cursor: pointer;
          }

          .tabs_t_a {
            color: #333;
            border-bottom: solid 2px #e50113;
          }
        }

        .tabs_con {
          padding: 0 40px 40px;

          .alipay_txt {
            font-size: 16px;
            font-weight: 400;
            color: #333;
            text-align: center;
            padding-top: 260px;
            background: url('assets/images/alipay-order.webp') center center no-repeat;
          }

          .wechat_txt {
            font-size: 16px;
            font-weight: 400;
            color: #333;
            text-align: center;
            padding-top: 260px;
            background: url('assets/images/wechat-order.webp') center center no-repeat;
          }

          .pay-qrcode {
            font-size: 16px;
            font-weight: 400;
            color: #333;
            text-align: center;
            padding: 78px 0 0;

            img {
              margin-bottom: 20px;
            }
          }

          .paypal-button-container {
            min-height: 120px;
            padding: 20px 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .paypal-loading {
            min-height: 198px;
          }
        }

        .btn_box {
          text-align: center;
          padding: 25px 0 40px 0;

          .pay_btn {
            width: 290px;
            height: 67px;
            background: #e50113;
            border-radius: 5px;
            text-align: center;
            line-height: 67px;
            font-size: 24px;
            color: #fff;
            margin: 0 auto;
          }
        }
      }

      .back_box {
        padding-left: 20px;
        margin: 26px 0;
        cursor: pointer;
        font-size: 14px;
        color: #949292;
      }
    }

    .safety_md_content {
      padding-bottom: 40px;
      display: flex;
      justify-content: center;
    }

    .safety_md {
      font-size: 16px;
      font-weight: 400;
      color: #999;
      padding-top: 100px;
      background: url('assets/images/order-dun.webp') center center no-repeat;
    }
  }
</style>
